export enum TrackASteps {
  IS_SOFTWARE = 0,
  PRODUCTS_BUSINESS_MODEL = 1,
  CUSTOMER_REFERENCES = 2,
  ADDRESS = 3,
  SHAREHOLDERS = 4,
  CERTIFICATIONS = 5,
  TECHNOLOGY = 6,
  COMPANY_FINISH = 7,
}

export enum TrackBSteps {
  COMPANY_SIZE = 0,
  KEYWORDS = 1,
  CRAWL_FINISH = 2,
}

export type ValidationTrack = 'company' | 'crawl';
